<div class="box" id="{{label}}" [ngClass]="{'checked': checked}"></div>
@if (label) {
  <div class="text">{{label}}</div>
}